import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { GetReportObraChecklistResponse } from "../../../data/daos/read/get_report_obra_checklist";
import { IGetReportObraChecklistUseCase } from "../../../presentation/useCases/read/get_report_obra_checklist_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportObraChecklistUseCase
 */

export class GetReportObraChecklistUseCase implements IGetReportObraChecklistUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportObraChecklist(
    requiredMimeType: ReportMimeType | null,
    idChecklistArea: number,
    area: string | null,
    servicos: number[] | null,
  ): Promise<GetReportObraChecklistResponse> {
    const servicoStr = servicos && servicos.length > 0 ? servicos.filter(x => x !== 0).join(',') : null;
    return await this.repository.getReportObraChecklist(
      requiredMimeType,
      idChecklistArea,
      area ?? "",
      servicoStr,
    );
  }
}
